var BSPageSpeed = function () {
  var globalThat = this;
  this.json = {};

  BSPageSpeed.prototype.init = function () {
    if (!_checkPerformanceObject()) {
      return false;
    }
    this.domLoadTime();
    this.pageLoadTime();
    this.device();
    this.pageLocation();
    this.pageSpeedObj();
    this.getQueryObj();
    
    //send EDS
    this.sendDataToEdS();
  };

  function convertSecToMiliSec(num) {
    return num * 0.001;
  }

  function _checkPerformanceObject() {
    return window.performance ? true : false;
  }

  BSPageSpeed.prototype.loadWebCoreVitals = function () {
    (function () {
      var script = document.createElement('script');
      script.src =
        'https://unpkg.com/web-vitals@4/dist/web-vitals.attribution.iife.js';
      script.onload = function () {
        webVitals.onCLS(loadCWVmetric);
        webVitals.onINP(loadCWVmetric);
        webVitals.onLCP(loadCWVmetric);
        webVitals.onTTFB(loadCWVmetric);
        webVitals.onFCP(loadCWVmetric);
      };
      document.head.appendChild(script);
    })();
  }

  function loadCWVmetric(metric) {
    var localObj = {},
    sendToBeacon = true;
    if (metric.hasOwnProperty('name')) {
      switch (metric.name) {
        case "TTFB":
          globalThat.json.TTFB = parseFloat(metric.value.toFixed(2));
          break;
        case "FCP":
          globalThat.json.FCP = parseFloat(metric.value.toFixed(2));
          break;
        case "LCP":
          localObj.LCP = parseFloat(metric.value.toFixed(4));
          if (metric.hasOwnProperty('attribution')) {
            localObj.LCP_entry = metric.attribution;
          }

          //Send Event
          if (EDS.hasOwnProperty('logEvent')) {
            EDS.logEvent('WordpressPerformanceStats', EDS.webEventsPii, 
              bsLib.extend(BSPageSpeed.json, localObj),
              null,
              sendToBeacon
            );
          }
          break;
        case "CLS":
          localObj.CLS = parseFloat(metric.value.toFixed(4));
          if (metric.hasOwnProperty('attribution')) {
            localObj.CLS_entry = metric.attribution;
          }

          //Send Event
          if (EDS.hasOwnProperty('logEvent')) {
            EDS.logEvent('WordpressPerformanceStats', EDS.webEventsPii, 
              bsLib.extend(BSPageSpeed.json, localObj),
              null,
              sendToBeacon
            );
          }
          break;
        case "INP":
          localObj.INP = parseFloat(metric.value.toFixed(4));
          if (metric.hasOwnProperty('attribution')) {
            localObj.INP_entry = metric.attribution;
          }

          //Send Event
          if (EDS.hasOwnProperty('logEvent')) {
            EDS.logEvent('WordpressPerformanceStats', EDS.webEventsPii, 
              bsLib.extend(BSPageSpeed.json, localObj),
              null,
              sendToBeacon
            );
          }
          break;
        default:
      }
    }
  }

  BSPageSpeed.prototype.domLoadTime = function () {
    var domLoadingTime = window.performance.timing.domContentLoadedEventEnd - window.performance.timing.navigationStart;
    this.json.dom_load_time = convertSecToMiliSec(domLoadingTime);
  };

  BSPageSpeed.prototype.pageLoadTime = function () {
    var pageLoadTime = window.performance.timing.domComplete - window.performance.timing.connectStart;
    this.json.page_load_time = convertSecToMiliSec(pageLoadTime);
  };

  BSPageSpeed.prototype.pageLocation = function () {
    this.json.page_location = [location.protocol, '//', location.host, location.pathname].join('');
  };

  BSPageSpeed.prototype.pageSpeedObj = function () {
    this.json.pagespeed = {
      JS: pageSpeedJs(),
      IMG: pageSpeedIMG(),
      IFRAME: pageSpeedIFRAME(),
    };
  };

  BSPageSpeed.prototype.getQueryObj = function () {

    //query params
    var paramsObj = {};
    if (window.location.search != '') {
      paramsObj = location.search
        .slice(1)
        .split('&')
        .map(function (p) {
          return p.split('=');
        })
        .reduce(function (obj, pair) {
          if (pair.length >= 2) {
            obj[pair[0]] = pair[1];
          }
          return obj;
        }, {});
    }

    //add urls params
    this.json.url_params = paramsObj;

    //add cache id
    this.json.cache_id = pageUniqID;
  };

  function pathInfoFunc(s) {
    s = s.match(/(.*?\/)?(([^/]*?)(\.[^/.]+?)?)(?:[?#].*)?$/);
    return { path: s[1], file: s[2], name: s[3], ext: s[4] };
  }

  function pageSpeedIMG() {
    var r = [],
      imgTag = document.querySelectorAll('img');

    for (var k = 0; k < imgTag.length; k++) {
      var imgEle = imgTag[k];
      if (imgEle) {
        var src =
          imgEle.getAttribute('data-lazy-src') === null
            ? imgEle.getAttribute('src')
            : imgEle.getAttribute('data-lazy-src');
        if (src) {
          var pathInfo = pathInfoFunc(src);

          if (pathInfo.ext) {
            r.push({
              src: pathInfo.file,
              lazy: imgEle.classList.contains('b-lazy'),
              width: imgEle.getAttribute('width') ? imgEle.getAttribute('width') : false,
              height: imgEle.getAttribute('height') ? imgEle.getAttribute('width') : false,
            });
          }
        }
      }
    }

    return r;
  }

  function pageSpeedIFRAME() {
    var r = [],
      iframeTag = document.querySelectorAll('iframe');

    for (var k = 0; k < iframeTag.length; k++) {
      var iframeEle = iframeTag[k];
      if (iframeEle) {
        var src =
          iframeEle.getAttribute('data-lazysrc') === null
            ? iframeEle.getAttribute('src')
            : iframeEle.getAttribute('data-lazysrc');
        if (src) {
          r.push({
            src: src,
            lazy: iframeEle.classList.contains('b-lazy'),
            width: iframeEle.getAttribute('width') ? iframeEle.getAttribute('width') : false,
            height: iframeEle.getAttribute('height') ? iframeEle.getAttribute('width') : false,
          });
        }
      }
    }

    return r;
  }

  jsonPS = {};
  function checkJsDeferAsync(ele, n) {
    var r = {};

    if (ele.getAttribute('defer') !== null) {
      r.defer = true;
    } else if (ele.getAttribute('async') !== null) {
      r.async = true;
    } else {
      r.defer = false;
      jsonPS[n] = false;
    }
    return r;
  }

  function pageSpeedJs() {
    var r = {},
      amplitudeJs = document.querySelector(
        "script[src*='wp-content/themes/browserstack/src/js/libraries/amplitude-4.1.1-min.gz.js']"
      ),
      googleAnalyticsJs = document.querySelector("script[src*='google-analytics.com/analytics.js']"),
      googleTagJs = document.querySelector("script[src*='www.googletagmanager.com/gtm.js?id=']"),
      bingJS = document.querySelector("script[src*='https://bat.bing.com/bat.js']"),
      sentryJS = document.querySelector("script[src*='https://js.sentry-cdn.com/']"),
      GoogleTapJS = document.querySelector("script[src*='https://accounts.google.com/gsi/client']"),
      fbEventsJS = document.querySelector("script[src*='https://connect.facebook.net/en_US/fbevents.js']"),
      twitterJS = document.querySelector("script[src*='https://static.ads-twitter.com/uwt.js']");

    //default EDS true
    r.EDS = { async: true };

    //Amplitude
    if (amplitudeJs) {
      r.amplitude = checkJsDeferAsync(amplitudeJs, 'amplitude');
    }

    //GTM
    if (googleTagJs) {
      r.GTM = checkJsDeferAsync(googleTagJs, 'GTM');
    }

    //GA
    if (googleAnalyticsJs) {
      r.GA = checkJsDeferAsync(googleAnalyticsJs, 'GA');
    }

    //GoogleOneTap
    if (GoogleTapJS) {
      r.GOneTap = checkJsDeferAsync(GoogleTapJS, 'GOneTap');
    }

    //Facebook
    if (fbEventsJS) {
      r.FB = checkJsDeferAsync(fbEventsJS, 'FB');
    }

    //Bing
    if (bingJS) {
      r.bing = checkJsDeferAsync(bingJS, 'bing');
    }

    //twitter
    if (twitterJS) {
      r.twitter = checkJsDeferAsync(twitterJS, 'twitter');
    }

    //Sentry
    if (sentryJS) {
      r.sentry = checkJsDeferAsync(sentryJS, 'sentry');
    }

    //VWO
    r.vwo = { show: typeof vwo_$ !== 'undefined' };

    return r;
  }

  BSPageSpeed.prototype.device = function () {
    var getBrowser = function () {
        // initial values for checks
        var UserAgent = navigator.userAgent, // store user agent
          browser = navigator.appName, // browser string [Netscape]
          version = '' + parseFloat(navigator.appVersion), // version string
          majorVersion = parseInt(navigator.appVersion, 10), // version number
          nameOffset, // used to detect other browsers name
          verOffset, // used to trim out version
          trimVersionString; // used to trim string

        // Opera
        if ((verOffset = UserAgent.indexOf('OPR') || (verOffset = UserAgent.indexOf('Opera'))) !== -1) {
          browser = 'Opera';
          version = UserAgent.substring(verOffset + 4);
          if ((verOffset = UserAgent.indexOf('Version')) !== -1) {
            version = UserAgent.substring(verOffset + 8);
          }

          // MSIE
        } else if ((verOffset = UserAgent.indexOf('MSIE')) !== -1) {
          browser = 'Microsoft Internet Explorer';
          version = UserAgent.substring(verOffset + 5);

          // IE 11 no longer identifies itself as MS IE
          // http://stackoverflow.com/questions/17907445/how-to-detect-ie11
        } else if (browser === 'Netscape' && UserAgent.indexOf('Trident/') !== -1) {
          browser = 'Microsoft Internet Explorer';
          version = UserAgent.substring(verOffset + 5);
          if ((verOffset = UserAgent.indexOf('rv:')) !== -1) {
            version = UserAgent.substring(verOffset + 3);
          }

          // Edge
        } else if ((verOffset = UserAgent.indexOf('Edge')) !== -1) {
          browser = 'Microsoft Edge';
          version = UserAgent.substring(verOffset + 5);

          // Yandex
        } else if ((verOffset = UserAgent.indexOf('YaBrowser')) !== -1) {
          browser = 'Yandex';
          version = UserAgent.substring(verOffset + 10, UserAgent.indexOf('Safari'));

          // Chrome
        } else if ((verOffset = UserAgent.indexOf('Chrome')) !== -1) {
          browser = 'Chrome';
          version = UserAgent.substring(verOffset + 7);

          // Chrome on iPad identifies itself as Safari. However it does mention CriOS.
        } else if ((verOffset = UserAgent.indexOf('CriOS')) !== -1) {
          browser = 'Chrome';
          version = UserAgent.substring(verOffset + 6);

          // Safari
        } else if ((verOffset = UserAgent.indexOf('Safari')) !== -1) {
          browser = 'Safari';
          version = UserAgent.substring(verOffset + 7);
          if ((verOffset = UserAgent.indexOf('Version')) !== -1) {
            version = UserAgent.substring(verOffset + 8);
          }

          // Firefox
        } else if ((verOffset = UserAgent.indexOf('Firefox')) !== -1) {
          browser = 'Firefox';
          version = UserAgent.substring(verOffset + 8);

          // Other browsers
        } else if ((nameOffset = UserAgent.lastIndexOf(' ') + 1) < (verOffset = UserAgent.lastIndexOf('/'))) {
          browser = UserAgent.substring(nameOffset, verOffset);
          version = UserAgent.substring(verOffset + 1);
        }

        // trim the version string
        if ((trimVersionString = version.indexOf(';')) !== -1) version = version.substring(0, trimVersionString);
        if ((trimVersionString = version.indexOf(' ')) !== -1) version = version.substring(0, trimVersionString);
        if ((trimVersionString = version.indexOf(')')) !== -1) version = version.substring(0, trimVersionString);

        majorVersion = parseInt('' + version, 10);
        if (isNaN(majorVersion)) {
          version = '' + parseFloat(navigator.appVersion);
          majorVersion = parseInt(navigator.appVersion, 10);
        }

        return {
          name: browser,
          version: majorVersion,
          versionString: version,
        };
      },
      getDevice = function () {
        var i,
          navigatorAppVersion = navigator.appVersion,
          UserAgent = navigator.userAgent,
          tabletStrings = [
            {
              s: 'iPad',
              r: /iPad/,
            },
            {
              s: 'Samsung Galaxy',
              r: /SCH-I800/,
            },
            {
              s: 'Samsung',
              r: /SM-T/,
            },
            {
              s: 'Motorola',
              r: /xoom/,
            },
            {
              s: 'Kindle',
              r: /kindle/,
            },
          ],
          phoneStrings = [
            {
              s: 'iPhone',
              r: /iPhone/,
            },
            {
              s: 'iPod',
              r: /iPod/,
            },
            {
              s: 'blackberry',
              r: /blackberry/,
            },
            {
              s: 'android 0.5',
              r: /android 0.5/,
            },
            {
              s: 'htc',
              r: /htc/,
            },
            {
              s: 'lg',
              r: /lg/,
            },
            {
              s: 'lg',
              r: /LG/,
            },
            {
              s: 'midp',
              r: /midp/,
            },
            {
              s: 'mmp',
              r: /mmp/,
            },
            {
              s: 'mobile',
              r: /mobile/,
            },
            {
              s: 'nokia',
              r: /nokia/,
            },
            {
              s: 'opera mini',
              r: /opera mini/,
            },
            {
              s: 'palm',
              r: /palm|PalmSource/,
            },
            {
              s: 'pocket',
              r: /pocket/,
            },
            {
              s: 'psp',
              r: /psp|Playstation Portable/,
            },
            {
              s: 'sgh',
              r: /sgh/,
            },
            {
              s: 'smartphone',
              r: /smartphone/,
            },
            {
              s: 'symbian',
              r: /symbian/,
            },
            {
              s: 'treo mini',
              r: /treo mini/,
            },
            {
              s: 'SonyEricsson',
              r: /SonyEricsson/,
            },
            {
              s: 'Samsung',
              r: /Samsung/,
            },
            {
              s: 'Samsung',
              r: /SM-G/,
            },
            {
              s: 'Samsung',
              r: /SM-A/,
            },
            {
              s: 'Samsung',
              r: /SM-N/,
            },
            {
              s: 'Samsung',
              r: /SM-J/,
            },
            {
              s: 'Google Pixel',
              r: /Pixel/,
            },
            {
              s: 'Nexus',
              r: /Nexus/,
            },
            {
              s: 'Oneplus',
              r: /ONEPLUS/,
            },
            {
              s: 'Motorola',
              r: /XT/,
            },
            {
              s: 'MobileExplorer',
              r: /MobileExplorer/,
            },
            {
              s: 'Benq',
              r: /Benq/,
            },
            {
              s: 'Windows Phone',
              r: /Windows Phone/,
            },
            {
              s: 'Windows Mobile',
              r: /Windows Mobile/,
            },
            {
              s: 'IEMobile',
              r: /IEMobile/,
            },
            {
              s: 'Windows CE',
              r: /Windows CE/,
            },
            {
              s: 'Nintendo Wii',
              r: /Nintendo Wii/,
            },
          ];

        var isTablet = false,
          isPhone = false,
          device = '';

        for (i in tabletStrings) {
          if (tabletStrings[i].r.test(UserAgent)) {
            device = tabletStrings[i].s;
            isTablet = true;
            break;
          }
        }
        if (device === '') {
          for (i in phoneStrings) {
            if (phoneStrings[i].r.test(UserAgent)) {
              device = phoneStrings[i].s;
              isPhone = true;
              break;
            }
          }
        }

        // if they are on tablet or phone
        var isMobile = isTablet || isPhone;
        if (!isMobile) {
          isMobile = /Mobile|mini|Fennec|Android/.test(navigatorAppVersion);
        }

        return {
          screen: {
            width: screen.width,
            height: screen.height,
          },
          device: device,
          isTablet: isTablet,
          isMobile: isMobile,
          isPhone: isPhone,
        };
      },
      getOS = function () {
        var navigatorAppVersion = navigator.appVersion,
          UserAgent = navigator.userAgent,
          osVersion = 'unknown',
          os = 'unknown',
          clientString,
          clientStrings = [
            {
              s: 'Windows 3.11',
              r: /Win16/,
            },
            {
              s: 'Windows 95',
              r: /(Windows 95|Win95|Windows_95)/,
            },
            {
              s: 'Windows ME',
              r: /(Win 9x 4.90|Windows ME)/,
            },
            {
              s: 'Windows 98',
              r: /(Windows 98|Win98)/,
            },
            {
              s: 'Windows CE',
              r: /Windows CE/,
            },
            {
              s: 'Windows 2000',
              r: /(Windows NT 5.0|Windows 2000)/,
            },
            {
              s: 'Windows XP',
              r: /(Windows NT 5.1|Windows XP)/,
            },
            {
              s: 'Windows Server 2003',
              r: /Windows NT 5.2/,
            },
            {
              s: 'Windows Vista',
              r: /Windows NT 6.0/,
            },
            {
              s: 'Windows 7',
              r: /(Windows 7|Windows NT 6.1)/,
            },
            {
              s: 'Windows 8.1',
              r: /(Windows 8.1|Windows NT 6.3)/,
            },
            {
              s: 'Windows 8',
              r: /(Windows 8|Windows NT 6.2)/,
            },
            {
              s: 'Windows NT 4.0',
              r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/,
            },
            {
              s: 'Windows ME',
              r: /Windows ME/,
            },
            {
              s: 'Android',
              r: /Android/,
            },
            {
              s: 'Open BSD',
              r: /OpenBSD/,
            },
            {
              s: 'Sun OS',
              r: /SunOS/,
            },
            {
              s: 'Linux',
              r: /(Linux|X11)/,
            },
            {
              s: 'iOS',
              r: /(iPhone|iPad|iPod)/,
            },
            {
              s: 'Mac OS X',
              r: /Mac OS X/,
            },
            {
              s: 'Mac OS',
              r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/,
            },
            {
              s: 'QNX',
              r: /QNX/,
            },
            {
              s: 'UNIX',
              r: /UNIX/,
            },
            {
              s: 'BeOS',
              r: /BeOS/,
            },
            {
              s: 'OS/2',
              r: /OS\/2/,
            },
            {
              s: 'Search Bot',
              r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/,
            },
          ];
        for (var id in clientStrings) {
          clientString = clientStrings[id];
          if (clientString.r.test(UserAgent)) {
            os = clientString.s;
            break;
          }
        }

        if (/Windows/.test(os)) {
          osVersion = /Windows (.*)/.exec(os)[1];
          os = 'Windows';
        }
        if (UserAgent) {
          switch (os) {
            case 'Mac OS X':
              osVersion = /Mac OS X (10[\.\_\d]+)/.exec(UserAgent)[1];
              break;

            case 'Android':
              osVersion = /Android ([\.\_\d]+)/.exec(UserAgent)[1];
              break;

            case 'iOS':
              osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(navigatorAppVersion);
              osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
              break;
          }
        }

        return {
          name: os,
          versionString: osVersion,
        };
      };
    this.json.userAgent = navigator.userAgent;
    this.json.browser = getBrowser();
    this.json.device = getDevice();
    this.json.os = getOS();
  };

  /***
  ** 
  Ref: https://github.com/sindresorhus/devtools-detect
  ***/
  var devtools = {
      isOpen: false,
      orientation: undefined,
    },
    threshold = 160;

  // for older browser version check for globalThis object
  if (typeof globalThis === 'undefined') {
    var globalThis = window;
  }

  var emitEvent = function emitEvent(isOpen, orientation) {
    globalThis.dispatchEvent(
      new globalThis.CustomEvent('devtoolschange', {
        detail: {
          isOpen: isOpen,
          orientation: orientation,
        },
      })
    );
  };

  var detectDevtoolsFn = function detectDevtoolsFn() {
    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0],
      _refEmitEvents = _ref.emitEvents,
      emitEvents = _refEmitEvents === undefined ? true : _refEmitEvents;

    var widthThreshold = globalThis.outerWidth - globalThis.innerWidth > threshold,
      heightThreshold = globalThis.outerHeight - globalThis.innerHeight > threshold,
      orientation = widthThreshold ? 'vertical' : 'horizontal';

    if (
      !(heightThreshold && widthThreshold) &&
      ((globalThis.Firebug && globalThis.Firebug.chrome && globalThis.Firebug.chrome.isInitialized) ||
        widthThreshold ||
        heightThreshold)
    ) {
      if ((!devtools.isOpen || devtools.orientation !== orientation) && emitEvents) {
        emitEvent(true, orientation);
      }

      devtools.isOpen = true;
      devtools.orientation = orientation;
    } else {
      if (devtools.isOpen && emitEvents) {
        emitEvent(false, undefined);
      }

      devtools.isOpen = false;
      devtools.orientation = undefined;
    }
  };

  BSPageSpeed.prototype.sendDataToEdS = function () {
    if (Object.keys(this.json).length) {
      var intVar = 0,
        loopForInt = false;
      var pageSpeedInterval = setInterval(function () {
        if (EDS.hasOwnProperty('logEvent') || intVar > 10) {
          loopForInt = true;
        }
        if (loopForInt) {
          if (EDS.hasOwnProperty('logEvent')) {
            //EDS Async
            bsLib.EDSAsync = typeof bsLib.EDSAsync === 'undefined' ? true : bsLib.EDSAsync;
            BSPageSpeed.json.pagespeed.JS.EDS.async = bsLib.EDSAsync;
            if (!bsLib.EDSAsync) {
              jsonPS['EDS'] = false;
            }
          }

          //load CWV lib
          globalThat.loadWebCoreVitals();

          //Slack Alert
          if (Object.keys(jsonPS).length) {
            detectDevtoolsFn({ emitEvents: false }); // call devtools fn to check if it is open or not

            if (!devtools.isOpen) {
              //ajax
              bsLib.ajax(
                'POST',
                bsLib.railsHost() + '/wp-admin/admin-ajax.php',
                {
                  action: 'bstack_pagespeed_ajax_alert',
                  id: 'bstack-pagespeed-ajax-alert', //id use for transist in ajax
                  s: 'PageSpeed Defer Check',
                  m: JSON.stringify(jsonPS),
                  u: window.location.href,
                },
                true, //async
                {
                  'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
                }, //request header
                function () {}, //success
                function () {} //error object
              );
            }
          }
          clearInterval(pageSpeedInterval);
        }
        intVar += 1;
      }, 300);
    }
  };
};
